import { ContentDataBlockRaw } from './Content';

type Props = {
  block: ContentDataBlockRaw;
};

export default function Raw({ block }: Props) {
  return <div className='Content__raw' dangerouslySetInnerHTML={{ __html: block.data.html }} />;
}
